import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  NOTIFICATION_NOT_FOUND: 'Notification was not found.',
  NOTIFICATION_ACCESS_DENIED:
    'You do not have access to this notification.',
  NOTIFICATION_ALREADY_READ: 'Notification is already read.',
  NOTIFICATION_PREFERENCES_NOT_AVAILABLE:
    'Notification preferences are not currently available.',
  NOTIFICATION_PREFERENCE_NOT_EDITABLE:
    'This notification preference cannot be changed.',
  NOT_FOUND: 'Notification was not found.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Check the notification request.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
  ROUTE_NOT_FOUND: 'Notification history is not currently available.',
};

export function notificationErrorMessage(
  error: unknown,
  fallback = 'Unable to load notifications.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    if (MESSAGES[code]) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  return fallback;
}
